import { override } from 'flarum/common/extend';
import Discussion from 'flarum/common/models/Discussion';
import Post from 'flarum/common/models/Post';

export default function () {
  Discussion.prototype.treeTopPostIds = function () {
    // @ts-ignore
    return this.rawRelationship<Post[]>('treeTopPosts')?.map((link) => link.id) ?? [];
  };
}
